import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./helpers/base-query";
import { gatewayApiInstance } from "./axios/api-instances";
import {
  StaffStoreAppDetailsVariables,
  StaffStoreAppDetailsResponse,
  StaffStoreAppsResponse,
  StaffStoreDetailsVariables,
  StaffStoreDetailsResponse,
  StaffStoresResponse,
  StaffStoresVariables,
  LoginVariables,
  LoginResponse,
  StaffMeResponse,
} from "./types";

const baseQuery = axiosBaseQuery(gatewayApiInstance);

export const gatewayApi = createApi({
  reducerPath: "gatewayApi",
  baseQuery,
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginVariables>({
      query: ({ username, password }) => ({
        url: `/gateway/staff/login`,
        method: "POST",
        data: {
          username,
          password,
        },
      }),
    }),
    logout: builder.mutation<void, void>({
      query: () => ({
        url: `/gateway/staff/logout`,
        method: "POST",
      }),
    }),
    staffMe: builder.query<StaffMeResponse, void>({
      query: () => ({
        url: `/gateway/staff/me`,
        method: "GET",
      }),
    }),
    staffStores: builder.query<StaffStoresResponse, StaffStoresVariables>({
      query: (params) => ({
        url: `/gateway/staff/stores`,
        params,
        method: "GET",
      }),
    }),
    staffStoreDetails: builder.query<StaffStoreDetailsResponse, StaffStoreDetailsVariables>({
      query: (params) => ({
        url: `/gateway/staff/stores/${params.store_key}`,
        method: "GET",
      }),
    }),
    staffStoreApps: builder.query<StaffStoreAppsResponse, StaffStoreDetailsVariables>({
      query: (params) => ({
        url: `/gateway/staff/stores/${params.store_key}/apps`,
        method: "GET",
      }),
    }),
    staffStoreAppDetails: builder.query<StaffStoreAppDetailsResponse, StaffStoreAppDetailsVariables>({
      query: (params) => ({
        url: `/gateway/staff/stores/${params.store_key}/apps/${params.app_key}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useStaffMeQuery,
  useLazyStaffStoresQuery,
  useStaffStoresQuery,
  useLazyStaffStoreAppDetailsQuery,
} = gatewayApi;
